import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { projects, projectCategories } from '../data/projectsData';
import '../styles/projects.css';

const Projects = () => {
    const [activeFilter, setActiveFilter] = useState('all');

    const filteredProjects = projects.filter(project => 
        activeFilter === 'all' || project.category === activeFilter
    );

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <section id="projects" className="projects">
            <div className="section-header">
                <span className="subtitle">Portfolio</span>
                <h2>Featured Projects</h2>
            </div>

            <div className="projects-filter">
                {projectCategories.map(category => (
                    <button
                        key={category.id}
                        className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
                        data-filter={category.id}
                        onClick={() => setActiveFilter(category.id)}
                    >
                        {category.label}
                    </button>
                ))}
            </div>

            <div className="project-grid" id="project-grid">
                {filteredProjects.length > 0 ? (
                    filteredProjects.map(project => (
                        <div key={project.id} className="project-card" data-category={project.category}>
                            <Link to={`/project/${project.id}`} className="project-link-wrapper">
                                <div className="project-content">
                                    <div className="project-image">
                                        <img src={project.imageUrl} alt={project.title} />
                                    </div>
                                    <div className="project-info">
                                        <div className="project-tags">
                                            {project.tags.map(tag => (
                                                <span key={tag}>{tag}</span>
                                            ))}
                                        </div>
                                        <h3>{project.title}</h3>
                                        <p>{project.description}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))
                ) : (
                    <div className="no-projects">
                        <i className="fas fa-folder-open"></i>
                        <h3>No Projects Found</h3>
                        <p>There are no projects in the {activeFilter === 'all' ? 'portfolio' : activeFilter} category yet.</p>
                    </div>
                )}
            </div>

            <div className="projects-cta">
                <Link to="/projects" className="view-all-btn">
                    View All Projects
                    <i className="fas fa-arrow-right"></i>
                </Link>
            </div>
        </section>
    );
}

export default Projects;